import type { Maybe } from '@/shared/libs';

import {
  DASHBOARD_PATH_BY_ROLE,
  ROLE_BY_BACKEND_ROLE,
  UserRoleEnum,
} from '../model/role';

const isBackendUserRole = (
  role: string,
): role is keyof typeof ROLE_BY_BACKEND_ROLE => role in ROLE_BY_BACKEND_ROLE;

export const resolveUserRole = (
  role: Maybe<string>,
): UserRoleEnum | undefined => {
  if (!role || !isBackendUserRole(role)) {
    return undefined;
  }

  return ROLE_BY_BACKEND_ROLE[role];
};

export const resolveDashboardPath = (
  role: Maybe<string>,
): string | undefined => {
  const resolvedRole = resolveUserRole(role);

  if (!resolvedRole) {
    return undefined;
  }

  return DASHBOARD_PATH_BY_ROLE[resolvedRole];
};

export const canAccessRole = (
  role: Maybe<string>,
  allowedRoles: readonly UserRoleEnum[],
): boolean => {
  const resolvedRole = resolveUserRole(role);

  if (!resolvedRole) {
    return false;
  }

  return allowedRoles.includes(resolvedRole);
};
